import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { AppearanceControls } from "@/components/appearance-controls";
import { profileQuery } from "@/lib/queries";
import { authSnapshot } from "@/stores/auth";

/** Signed-in pages that take the whole screen: no rail, no header. */
export const Route = createFileRoute("/_full")({
  beforeLoad: ({ location }) => {
    if (!authSnapshot().accessToken) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
  },
  loader: ({ context }) => context.queryClient.ensureQueryData(profileQuery()),
  component: FullLayout,
});

/** These screens have no header to hang the controls off, so they take the corner. */
function FullLayout() {
  return (
    <>
      <Outlet />
      <AppearanceControls />
    </>
  );
}
